import { Phone, Mail, Instagram, MapPin } from "lucide-react";
import { CONTACT } from "../data/content";

export const Footer = () => {
  return (
    <footer
      id="footer"
      data-testid="footer-section-container"
      className="bg-[#1E4320] text-white px-4 sm:px-8 lg:px-16 pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-10 md:gap-8 pb-12 border-b border-white/10">
          <div>
            <div className="flex items-center mb-5">
              <img
                src="/logo.png"
                alt="Aaroh Farms logo"
                className="h-20 w-20 object-contain bg-white/95 rounded-full p-1.5"
              />
            </div>
            <p className="text-white/60 leading-relaxed max-w-xs">
              Exclusive 36 farmhouse plots of 4000-5500 Sq. Ft. each, nestled in
              nature near Sonkatch, MP.
            </p>
          </div>

          <div>
            <h3 className="font-serif text-lg mb-5">Get in Touch</h3>
            <ul className="space-y-4 text-white/70">
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#EAC9B8] mt-0.5 shrink-0" />
                <span>{CONTACT.office}</span>
              </li>
              <li>
                <a
                  data-testid="footer-phone-link"
                  href={`tel:+91${CONTACT.phone}`}
                  className="flex items-center gap-3 transition-colors hover:text-white"
                >
                  <Phone className="h-5 w-5 text-[#EAC9B8] shrink-0" />
                  +91 {CONTACT.phone}
                </a>
              </li>
              <li>
                <a
                  data-testid="footer-email-link"
                  href={`mailto:${CONTACT.email}`}
                  className="flex items-center gap-3 transition-colors hover:text-white break-all"
                >
                  <Mail className="h-5 w-5 text-[#EAC9B8] shrink-0" />
                  {CONTACT.email}
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-serif text-lg mb-5">Follow Us</h3>
            <a
              data-testid="footer-instagram-link"
              href={CONTACT.instagramUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 rounded-full border border-white/20 px-5 py-3 transition-all hover:bg-white hover:text-[#1E4320]"
            >
              <Instagram className="h-5 w-5" />@{CONTACT.instagram}
            </a>
          </div>
        </div>

        <div className="pt-8 text-center text-sm text-white/50">
          <p>© {new Date().getFullYear()} Aaroh Farms. All rights reserved.</p>
        </div>

        <div
          data-testid="footer-disclaimer-section"
          className="mt-8 rounded-2xl border border-white/15 bg-black/20 px-6 py-6"
        >
          <h4 className="font-serif text-sm uppercase tracking-[0.2em] text-[#EAC9B8] mb-3">
            Disclaimer
          </h4>
          <p
            data-testid="footer-disclaimer-text"
            className="text-xs leading-relaxed text-white/55"
          >
            Aaroh Farms is an agricultural land project intended for farmhouse
            use. We exclusively sell agricultural land parcels within the
            project. We do not construct or sell built farmhouses, villas, or any
            other built-up properties. Buyers are free to design and build their
            own farmhouses on their plots as per applicable norms. All images,
            renders, and visuals shown on this website are for representational
            purposes only and may differ from the actual site. Distances,
            timelines, and other details mentioned are approximate and subject to
            change. This website is for information purposes only and does not
            constitute an offer or a contract.
          </p>
        </div>
      </div>
    </footer>
  );
};
